<div class="page-layout blank fullwidth p-12" style="height: 1px; overflow-y: scroll; top: 1px;" >
  <div class="customer-list-container">
    <div class="top-bar">
      <!-- <input type="text" placeholder="Search by Name" />
      <button class="create-btn" (click)="confirmDetails()">
        <span>+</span> Create New Customer
      </button> -->
      <div class="SearchBarPlaceholder">
        <div class="search">
          <div class="input-container">
            <input type="text" class="search-input" [(ngModel)]="searchText" (keydown.enter)="onSearch()" (input)="filterRequests()">
            <span *ngIf="searchText" class="close-button" (click)="clearSearch()">✖</span>
            <div class="scroll-text-container" *ngIf="!searchText">
              <div class="SearchBarIcon">
                <i class="material-icons-search">search</i>
              </div>
              <div class="scroll-text">
                <div id="animationText-1" class="SearchBarAnimationText">Search By "Customer ID"</div>
                <div id="animationText-2" class="SearchBarAnimationText">Search By " Customer Name"</div>
                <div id="animationText-3" class="SearchBarAnimationText">Search By "Mobile Number"</div>
                <div id="animationText-4" class="SearchBarAnimationText">Search By "GST Number"</div>
              </div>
            </div>
          </div>
          <button #myButton class="create-booking" (click)="connewCustomer()">Create New Customer</button>
        </div>
  </div>
    </div>

    <ng-template #dynamicContainer></ng-template>
  
    <!-- Job Card Start -->
    <!-- <div class="customer-card">
      <div class="card-top">
        <div >
            <div class="repeat-tag">Repeat Customer</div>
            <span class="invoice-label">Invoice Created</span>
        </div>
          <div class="details">
            <div class="header-top-row">
              <div class="order-icon">
                <div class="car-img">
                  <img [src]="make" alt="Car Make" class="model-icon">
                </div>
              </div>
              <div>
                <div class="job-id">Job Card ID # 1313</div>
                <div class="model">Altroz, Petrol</div>
                <div class="variant">ALTROZ 1.2L XZ</div>
                <div class="regno">KA03MX5056</div>
              </div>
            </div>
        </div>
        </div>
  
      <div class="card-bottom">
        <div class="user">Test user</div>
        <div class="mobile">9066166984</div>
      </div>
  
      <div class="footer">
        <span>Placed On 12 Apr 2025, 10:00 AM</span>
        <a class="view-btn" >
          <span class="job-card">View Details</span>
          <i class="material-icons" style="color: #4caf50; float: left;">arrow_right</i> 
        </a>
      </div>
    </div> -->

    <div class="customer-card" *ngFor="let customer of customerList">
      <div class="card-top">
        <div>
          <div class="repeat-tag" >
            {{ customer.customerType }}
          </div>
          <!-- <span class="invoice-label">Invoice Created</span> -->
        </div>
        <div class="details">
          <div class="header-top-row">
            <!-- <div class="order-icon">
              <div class="custom-check-icon">
                <i class="material-icons">check</i>
              </div>
            </div> -->
            <div class="order-icon">
              <img src="../../../../assets/images/order-details/ic_order.svg">
            </div>
            <div style="padding: 0px 10px;">
              <div class="job-id">Customer ID # {{ customer.customerId }}</div>
              <!-- <div class="model">
                {{ customer.customerType === 'Business Customer' ? 'Business (with GST)' : 'Individual (with no GST)' }}
              </div> -->
              <div class="variant">{{ customer.companyName || customer.name }}</div>
              <div *ngIf="customer.totalVehicles > 0" class="regno">  {{ customer.totalVehicles }} {{ customer.totalVehicles === 1 ? 'Vehicle' : 'Vehicles' }} </div>
              <div class="regno" *ngIf="customer.gstNumber">GSTIN: {{ customer.gstNumber }}</div>
              <!-- <div class="regno">Outstanding amt: {{ customer.outstandingAmount }}</div> -->
            </div>
          </div>
        </div>
      </div>
    
      <div class="card-bottom">
        <!-- <div class="user">{{ customer.name }}</div> -->
        <div class="user">Outstanding amt: {{ customer.outstandingAmount }}</div>
        <div class="mobile">{{ customer.mobile }}</div>
      </div>
    
      <div class="footer">
        <div>
          <span *ngIf="customer.lastJob">Last Job: {{ customer.lastJob | date:'dd MMM yyyy' }} </span> 
        </div>
        <a class="view-btn" [routerLink]="['/customer-details', customer.mobile, customer.customerId]">
          <span class="job-card">View Details</span>
          <i class="material-icons" style="color: #4caf50; float: left;">arrow_right</i>
        </a>
      </div>
    </div>
    
    <div class="no-image-car">
      <div class="no-img" *ngIf="customerList.length === 0">
        <img [src]="emptyList" alt="No data available" />
        <h1 class="no-request-text">No customer Found</h1>
        <div class="eidt-text">Edit filter or go back to my Customer page</div>
        <button class="go-back-btn" (click)="clearFilters()" >Go to My Customer</button>
      </div>
    </div>
    
    <!-- Job Card End -->
  </div>
</div>
  

  <!-- GST Side Slider -->
<div class="overlay" [class.visible]="gstDetails" (click)="closeAll()" ></div>
<div *ngIf="gstDetails" class="gst-side-slider">
  <div class="gst-slider-header">
      <mat-icon class="back-btn" (click)="closeGstSlider()">keyboard_backspace</mat-icon>
      <div class="getstarted-header">
          <div class="getstardet-text">Create New Customer</div>
          <!-- <span class="skip-text" (click)="skipForNow()">Skip for now</span> -->
      </div>
  </div>

  <div class="gst-slider-content">
      <div class="subtext-and-h3">
          <h3>Do you have GST number?</h3>
          
      </div>
      <div class="sub-text">15-digit GSTIN Number.</div>

      <!-- Radio Buttons -->
      <div class="radio-group">
        <label class="radio-container" [ngClass]="{'selected': hasGst === true}">
            <input type="radio" name="gst" [(ngModel)]="hasGst" [value]="true">
            Yes, I have GST Number
            <span class="custom-radio"></span>
        </label>

        <label class="radio-container" [ngClass]="{'selected': hasGst === false}">
            <input type="radio" name="gst" [(ngModel)]="hasGst" [value]="false">
            I don’t have GST Number
            <span class="custom-radio"></span>
        </label>
      </div>

  </div>

  <div class="slider-footer">
      <button class="continue-btn" (click)="continueNextStep()" [disabled]="hasGst === null" >Continue</button>
  </div>
  
</div>

<div class="overlay" [class.visible]="isCreateCustomerSliderOpen" (click)= "closeAll()"></div>
<div *ngIf="isCreateCustomerSliderOpen" class="side-slider-customer-address">
  <div class="customer-address-slider-header">
    <mat-icon class="back-btn" (click)="closeCreateCustomerSlider()">arrow_back</mat-icon>
    <div class="header-title">Create New Customer</div>
  </div>
  <form [formGroup]="customerForm" (ngSubmit)="confirmGarageCustomerDetails()">
    <div class="slider-content" style="margin-bottom: 40%;">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label >Name</mat-label>
        <input matInput formControlName="name" required  maxlength="20"/>
         <mat-error *ngIf="customerForm.get('name')?.hasError('required') || !customerForm.get('name')?.value">
                  Name is required
                </mat-error>
                <mat-error *ngIf="customerForm.get('name')?.hasError('pattern')">
                  Only alphabets are allowed in name
                </mat-error>
      </mat-form-field>
  
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Mobile</mat-label>
        <input matInput formControlName="mobile" required required maxlength="10" type="tel" pattern="[0-9]*"/>
        <mat-error *ngIf="customerForm.get('mobile')?.hasError('required') || !customerForm.get('mobile')?.value">
                  Mobile is required
                </mat-error>
                 <mat-error *ngIf="customerForm.get('mobile')?.hasError('pattern')">
                  Enter a valid 10-digit mobile number
                </mat-error>
      </mat-form-field>
  
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Email</mat-label>
        <input matInput formControlName="email" />
      </mat-form-field>

      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Rate Card Applicable</mat-label>
        <mat-select formControlName="rateCardApplicable" required>
          <mat-option *ngFor="let type of ratecardTypes" [value]="type">
            {{ type }}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="customerForm.get('rateCardApplicable')?.hasError('required')">
          Rate Card selection is required
        </mat-error>
      </mat-form-field>



  
      <div class="customer-details-slider-footer">
        <!-- <button mat-flat-button color="primary" type="submit" [disabled]="customerForm.invalid" class="customer-details-slider-footer-button">
          Create New Customer
        </button> -->
        <button mat-flat-button color="primary" type="submit" class="customer-details-slider-footer-button">
  Create New Customer
</button>

      </div>
      
    </div>
  </form>
  
</div>
<!-- ====================== GST SECOND-SLIDER -->
 
<!-- Second GST Slider (Hidden by Default) -->
 <div class="overlay" [class.visible]="showGstSecondSlider" (click)= "closeAll()"></div>
<div *ngIf="showGstSecondSlider" class="gst-second-slider">
  <div class="gst-slider-header">
      <mat-icon class="back-btn" (click)="closeSecondSlider()">keyboard_backspace</mat-icon>
      <div class="getstarted-header">
          <div class="getstardet-text">Create New Customer</div>
          <!-- <span class="skip-text" (click)="skipForNow()">Skip for now</span> -->
      </div>
  </div>

  <div class="gst-2nd-slider-content">
      <h3>Enter GST number</h3>
      <div class="sub-text">Your 15-digit GSTIN</div>

      <!-- GST Input Field -->
      <form [formGroup]="customerGstForm">
        <mat-form-field appearance="outline" class="gst-input-field" style="padding: 0px 20px;">
          <mat-label>Enter GST Number</mat-label>
          <input
            matInput
            formControlName="gstNumber"
            maxlength="15"
            (input)="validateGstInput()"
            required
          >
          <mat-error *ngIf="customerGstForm.get('gstNumber')?.hasError('required')">
            GST Number is required
          </mat-error>
          <!-- <mat-error *ngIf="customerGstForm.get('gstNumber')?.hasError('pattern')">
            GST Number must be 15 characters (A-Z & 0-9)
          </mat-error> -->
        </mat-form-field>
      </form>
      
    
    <!-- </form> -->
    
  </div>

  <div class="slider-footer">
    <button class="continue-btn"
            (click)="openBusinessSlider()"
            [disabled]="customerGstForm.get('gstNumber')?.hasError('required') || customerGstForm.get('gstNumber')?.value.length < 15">
      Continue
    </button>
  </div>
  
</div>

<!-- ================== gst 3nd-section-business-section============== -->
<div class="overlay" [class.visible]="showBusinessInfoSlider" (click)="closeAll()" ></div>
<div *ngIf="showBusinessInfoSlider" class="business-info-slider">
  <div class="business-slider-header">
      <mat-icon class="back-btn" (click)="closeBusinessSlider()">keyboard_backspace</mat-icon>
      <div class="getstarted-header">
          <div class="getstardet-text">Business Info</div>
      </div>
  </div>

  <div class="business-slider-content">
      <h3>Business Information</h3>
      <form [formGroup] = "customerGstForm">
            <!-- Business Name Field -->
            <mat-form-field appearance="outline" class="business-input-field">
              <mat-label id="businessName">Business/Company Name</mat-label>
              <input matInput formControlName="businessName" required  maxlength="20">
              <mat-error *ngIf="customerGstForm.get('businessName')?.hasError('required')">
                Business Name is required
              </mat-error>
            </mat-form-field>

            <!-- GST Input Field -->
            <mat-form-field appearance="outline" class="gst-input-field">
                <mat-label>GST Number (Optional)</mat-label>
                <input matInput formControlName="gstNumber" (input)="validateGstInput()" maxlength="15">
            </mat-form-field>

            <!-- Choose State Field -->
            <mat-form-field appearance="outline" class="state-input-field" style=" cursor: pointer;">
              <mat-label id="state">Choose your State</mat-label>
              <input 
                matInput
                formControlName="state"
                readonly
                (click)="openStateSlider()"
                required
                style="background-color: white; border: none; padding: 0px; cursor: pointer;"
              >
              <mat-error *ngIf="customerGstForm.get('state')?.hasError('required') || !customerGstForm.get('state')?.value">
                State is required
              </mat-error>
            </mat-form-field>
      </form>
      <div style="margin-bottom: 100px;">
        <h3>Customer Details</h3>
        <form [formGroup]="customerForm" >
            <div class="slider-content">
              <mat-form-field appearance="outline" class="full-width">
                <mat-label id="name">Name</mat-label>
                <input matInput formControlName="name" required  maxlength="20"/>
                <mat-error *ngIf="customerForm.get('name')?.hasError('required') || !customerForm.get('name')?.value">
                  Name is required
                </mat-error>
                <mat-error *ngIf="customerForm.get('name')?.hasError('pattern')">
                  Only alphabets are allowed in name
                </mat-error>
              </mat-form-field>
          
              <mat-form-field appearance="outline" class="full-width">
                <mat-label id="mobile">Mobile</mat-label>
                <input matInput formControlName="mobile" required required maxlength="10" type="tel" pattern="[0-9]*"/>
                <mat-error *ngIf="customerForm.get('mobile')?.hasError('required') || !customerForm.get('mobile')?.value">
                  Mobile is required
                </mat-error>
                 <mat-error *ngIf="customerForm.get('mobile')?.hasError('pattern')">
                  Enter a valid 10-digit mobile number
                </mat-error>
              </mat-form-field>
          
              <mat-form-field appearance="outline" class="full-width">
                <mat-label>Email</mat-label>
                <input matInput formControlName="email"/>
              </mat-form-field>

                 <mat-form-field appearance="outline" class="full-width" id="rateCardApplicable">
        <mat-label>Rate Card Applicable</mat-label>
        <mat-select formControlName="rateCardApplicable" required>
          <mat-option *ngFor="let type of ratecardTypes" [value]="type">
            {{ type }}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="customerForm.get('rateCardApplicable')?.hasError('required')">
          Rate Card selection is required
        </mat-error>
      </mat-form-field>
          
              <!-- <div class="customer-details-slider-footer">
                <button mat-flat-button color="primary" type="submit" [disabled]="customerForm.invalid" class="customer-details-slider-footer-button">
                  Create New Customer
                </button>
              </div> -->
            </div>
        </form>
      </div>
  </div>

  <div class="slider-footer-business">
<button class="continue-btn-business"
        (click)="openAddressSlider()"
         [disabled]="customerGstForm.invalid && customerForm.invalid">
  Continue
</button>
<!-- [disabled]="customerGstForm.invalid && (customerForm.get('name')?.hasError('required') || !customerForm.get('name')?.value) && customerForm.get('mobile')?.hasError('required')"> -->

              <!-- [disabled]="!businessName || businessName.trim() === ''" -->
  </div>

</div>

<!-- State Selection Sideslider -->
<div class="state-sideslider-overlay" *ngIf="stateSliderOpen">
  <div class="state-sideslider">
    <div class="state-sideslider-header">
      <mat-icon class="back-btn1" (click)="closeStateSlider()">keyboard_backspace</mat-icon>
      <h3>Select State</h3>
      <mat-icon (click)="closeStateSlider()" style="cursor: pointer;">close</mat-icon>
    </div>

    <!-- Search Bar -->
    <div class="state-SearchBarContainerNew">
      <div class="state-SearchBarButton">
        <div class="state-SearchBarIcon">
          <i class="material-icons-search-state">search</i>
        </div>
        <input
          type="text"
          placeholder="Search for States"
          [(ngModel)]="searchTextStates"
          (input)="filterStates()"
          class="state-SearchBarInput"
        />
        <div class="remove-search-suggestion-state" *ngIf="filteredStates.length" (click)="clearStateSearch()">
          <mat-icon>close</mat-icon>
        </div>
      </div>
    </div>

    <!-- Filtered State List -->
    <div class="state-list">
      <div *ngFor="let state of filteredStates" class="state-item" (click)="selectState(state)">
        {{ state.name }} <!-- Ensure 'name' matches the actual field in API response -->
      </div>
    </div>
  </div>
</div>

<!-- Address Slider -->
<div class="overlay" [class.visible]="showAddressSlider" (click)="closeAll()" ></div>
<div *ngIf="showAddressSlider" class="address-slider">
  <div class="address-slider-header">
    <mat-icon class="back-btn" (click)="closeAddressSlider()">keyboard_backspace</mat-icon>
    <div class="getstarted-header">
      <div class="getstardet-text">Address</div>
    </div>
  </div>

  <div class="address-slider-content">
    <h3>Enter Address</h3>

    <!-- ✅ Form starts here -->
     <!-- (ngSubmit)="confirmGarageCustomerDetails()" -->
    <form [formGroup]="addressForm" (ngSubmit)="saveAddressDetails()">
      <!-- Address Line 1 -->
      <mat-form-field appearance="outline" class="address-input-field">
        <mat-label>Address Line 1</mat-label>
        <input matInput formControlName="addressLine1">
        <mat-error *ngIf="af.addressLine1.hasError('required')">Address Line 1 is required</mat-error>
      </mat-form-field>

      <!-- Address Line 2 -->
      <mat-form-field appearance="outline" class="address-input-field">
        <mat-label>Address Line 2</mat-label>
        <input matInput formControlName="addressLine2">
        <mat-error *ngIf="af.addressLine2.hasError('required')">Address Line 2 is required</mat-error>
      </mat-form-field>

      <!-- Pincode -->
      <!-- <mat-form-field appearance="outline" class="address-input-field">
        <mat-label>Pincode</mat-label>
        <input matInput formControlName="pincode" maxlength="6" required>
        <mat-error *ngIf="af.pincode.hasError">Pincode is required</mat-error>
        <mat-error *ngIf="af.pincode.hasError('pattern')">Enter a valid 6-digit pincode</mat-error>
      </mat-form-field> -->
      <mat-form-field appearance="outline" class="address-input-field">
        <mat-label>Pincode</mat-label>
        <input matInput formControlName="pincode" maxlength="6">
        <mat-error *ngIf="af.pincode.touched && af.pincode.hasError('pattern')">
          Enter a valid 6-digit pincode
        </mat-error>
      </mat-form-field>
      

      <!-- City -->
      <mat-form-field appearance="outline" class="address-input-field">
        <mat-label>City</mat-label>
        <input matInput formControlName="city">
        <mat-error *ngIf="af.city.hasError('required')">City is required</mat-error>
      </mat-form-field>

      <!-- ✅ Submit Button should be inside the form -->
      <div class="slider-footer-Address">
        <button class="continue-btn" type="submit"(click)="onCreateCustomer()">Create Customer</button>
      </div>
    </form>
  </div>
</div>

<div class="overlay" [class.visible]="showBookingPopup" (click)= "closePopup()"></div>
<div class="popup-overlay" *ngIf="showBookingPopup">
  <div class="popup-box">
    <!-- <button class="close-button" (click)="closePopup()">×</button> -->
    <!-- <button class="close-modal" >
      
    </button> -->
    <div style="position: relative;">
      <img src="{{successIcon}}" alt="Success Icon" class="success-icon">
      <mat-icon (click)="closePopup()" style="float: right; cursor: pointer;">close</mat-icon>
      <h3 style=" font-weight: 800;">Customer Created </h3>
    </div>
    <p class="booking-id">Customer ID <strong>{{ customerID }}</strong></p>
    <p>{{ currentTime | date: 'dd MMM yyyy, hh:mm a' }}</p>
    <p>Let us deliver an awesome experience!</p>
    <button class="ok-button" (click)="closePopup()">OK, GOT IT</button>
  </div>
</div>







<!-- <div class="my-request"> -->

  <!-- Job Card Sidebar (Find My Car Sidebar) -->
  <div class="overlay" [class.visible]="isJobCardSidebarOpen" (click)="closeAll()" ></div>
  <!-- <div class="scroll-container" > -->
  <div class="job-card-sidebar" *ngIf="isJobCardSidebarOpen" (click)="$event.stopPropagation()">
    <!-- <div class="sidebar-header" (click)="onCreateJobCardClick()"> -->
    <div class="sidebar-header1" >
      <div class="close-btn-side-slider1">
        <mat-icon (click)="closeAll()" class="kybrdbckspc">keyboard_backspace</mat-icon>
        <h2>Create New Customer</h2>
      </div>

      <mat-icon (click)="closeAll()" class="close-sidebar">close</mat-icon>
    </div>
    <form class="container" [formGroup]="vehicleForm1" (ngSubmit)="onRegDecodeSubmit()">
      <label for="regNo" style="font-weight: bolder; ">We recommend to enter car number <span class="required">*</span></label>
      <div class="input-group">
        <span class="small-img"><img src="assets/images/my-job-card-images/circle.png" class="input-icon" alt="Car Number"> IND</span>
        <input id="regNo" placeholder="KA 04 JA54**" maxlength="13" style="font-weight: 800;" formControlName="regNo">
      </div>
      <div *ngIf="(vehicleForm1.get('regNo').invalid && vehicleForm1.get('regNo').touched || formSubmitted) || (vehicleForm1.get('regNo').invalid && formSubmitted)" style="color: red;">
      <!-- <div *ngIf="formSubmitted && vehicleForm1.invalid" style="color: red; margin-top: 10px;"> -->
        Please fill Correct Registration Number.
      </div>
  
      <input type="hidden" formControlName="rowKey">
      <input type="hidden" formControlName="variantKey">
  
      <ul class="info-list">
        <li><img src="assets/images/my-job-card-images/ic_check.png" class="circle-img" alt="Check Circle">
          <span class="get">Get accurate details</span>
        </li>
        <li><img src="assets/images/my-job-card-images/ic_check.png" class="circle-img" alt="Check Circle">
          <span class="get">Get 2X faster results</span>
        </li>
      </ul>
  
      <button type="submit" mat-raised-button color="accent" class="submit-btn" aria-label="VEHICLE"   [ngStyle]="{'background-color': vehicleForm1.invalid ? '#888' : '#144579'}"
      [disabled]="vehicleForm1.invalid">
        FIND MY CAR
      </button>
      <!-- <button mat-raised-button color="accent" class="submit-button" aria-label="VEHICLE" [disabled]="vehicleForm1.invalid">
        FIND MY CAR
    </button> -->
      <p class="manual-selection" (click)="redirectToManualSelection()" >
        Or select car manually</p>
    </form>
  </div>
  
  <!-- Confirmation Sidebar (After Find My Car) -->
  <div class="overlay" [class.visible]="isConfirmationSidebarOpen" (click)= "closeAll()"></div>
  <div class="confirmation-sidebar" *ngIf="isConfirmationSidebarOpen && jobCardDetails" (click)="$event.stopPropagation()">
      <div class="confirmation-content">
        <!-- <div class="header-container">
          <mat-icon class="back-arrow" (click)="toggleConfirmationSidebar()">arrow_back</mat-icon>
          <mat-icon style="color: #144579;">directions_car</mat-icon>
        </div> -->
        <div class="logo-container">
          <div class="logoandtext">
            <img class="logoimg"src="../../../../assets/images/logos/mobile_autoverse_logo.svg" alt="Autoverse Logo">
            <p style="font-size: 12px;"><strong>AUTOVERSE</strong></p>
          </div>
          <!-- <img class="shareimg"src="../../../../assets/images/share.png" alt="Share" (click)="shareDetails()" > -->
        </div>
        
        <h2 class="registration-number">{{jobCard.registrationNumber}}</h2>
        <div class="confirmdiv">Confirm your car details</div>
        <div class="details-item">
          <img src="assets/images/my-job-card-images/ic_check.png" alt="ic_check" class="circle-img">
          <div class="label">Make:</div>
          <div class="value">{{ jobCard.make }}</div>
        </div>
        <div class="details-item">
          <img src="assets/images/my-job-card-images/ic_check.png" alt="ic_check">
          <div class="label">Model:</div>
          <div class="value">{{ jobCard.model }}</div>
        </div>
        <div class="details-item">
          <img src="assets/images/my-job-card-images/ic_check.png" alt="ic_check">
          <div class="label">Variant:</div>
          <div class="value">{{ jobCard.variant }}</div>
        </div>
        <div class="details-item">
          <img src="assets/images/my-job-card-images/ic_check.png" alt="ic_check">
          <div class="label">MFG Year:</div>
          <div class="value">{{ jobCard.mfgYear }}</div>
        </div>
        <div class="details-item">
          <img src="assets/images/my-job-card-images/ic_check.png" alt="ic_check">
          <div class="label">Fuel:</div>
          <div class="value">{{ jobCard.fuelType }}</div>
        </div>
        <div class="details-item">
          <img src="assets/images/my-job-card-images/ic_check.png" alt="ic_check">
          <div class="label">VIN:</div>
          <div class="value">{{ jobCard.vin }}</div>
        </div>
        <button class="confirm-btn" (click)="confirmDetails()">Confirm</button>
        <button class="change-car-btn" (click)="toggleConfirmationSidebar()">Change Car</button>
      </div>
  </div>
<!-- </div> -->
<!-- </div> -->